import { Injectable } from '@angular/core';
import { EventType } from './event-type.model';
import { IEventV4TypeService } from './ievent-v4-type.service';
import { ApiCacheOptions, PagedResultGeneric } from '../../../shared/index';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventV4TypeService implements IEventV4TypeService {
  private _eventServiceBaseUrl: string = '/event/v2/eventtype/';

  private _cacheOptions: ApiCacheOptions;

  public constructor(private _eventApiService: EventsServiceApiService) {
    this._cacheOptions = this._eventApiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  getEventType = (eventType: string): Promise<EventType> => {
    let url: string = this._eventServiceBaseUrl + '?type=' + encodeURIComponent(eventType);
    return this._eventApiService.get(url, this._cacheOptions);
  };

  searchEventTypes = (searchParams: any, forceRefresh?: boolean): Promise<PagedResultGeneric<EventType>> => {
    let url: string = `${this._eventServiceBaseUrl}search`;
    const cacheOptions = forceRefresh ? this._eventApiService.getDefaultApiCacheOptionsForNoCache() : this._cacheOptions;
    return this._eventApiService.getPaged(url, searchParams, cacheOptions);
  };

  public getEventTypes = (): Promise<Array<string>> => {
    let url: string = `${this._eventServiceBaseUrl}all`;
    return this._eventApiService.get(url);
  };

  public upsertEventType = (eventType: EventType): Promise<string> => {
    let url: string = `${this._eventServiceBaseUrl}upsert`;
    return this._eventApiService.post(url, eventType).then((data: string): Promise<string> => {
      return Promise.resolve(data);
    });
  };

  public deleteEventType = (eventType: string, eventTypeToMigrateTo?: string): Promise<void> => {
    let url: string = `${this._eventServiceBaseUrl}?type=${encodeURIComponent(eventType)}&typeToMigrateTo=${encodeURIComponent(
      eventTypeToMigrateTo
    )}`;
    return this._eventApiService.deleteData(url, { typeToMigrateTo: eventTypeToMigrateTo }).then((): Promise<void> => {
      return Promise.resolve();
    });
  };
}
